import { render } from "./ProductPriceHistoryModal.vue?vue&type=template&id=7b2aae00&scoped=true"
import script from "./ProductPriceHistoryModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceHistoryModal.vue?vue&type=script&lang=js"

import "./ProductPriceHistoryModal.vue?vue&type=style&index=0&id=7b2aae00&scoped=true&lang=css"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2aae00"]])

export default __exports__